import axios from 'src/api';
import { NotificationManager } from 'react-notifications';
import { _getDashboardData, _getBalance } from 'src/api/DashboardRequest';
import { GETDASHBOARD_SUCCESS, GETBALANCE_SUCCESS } from '../types';

export const getDashboardData = () => {
  return async (dispatch) => {
    try {
      const { data } = await _getDashboardData();

      if (data.error.status == 1) {
        NotificationManager.error(data.error.message, 'Error');
        return -1;
      } else {
        dispatch({ type: GETDASHBOARD_SUCCESS, payload: data.content });
        NotificationManager.success(
          'Dashboard Information up to date',
          'Success'
        );
        return 1;
      }
    } catch (error) {
      console.log('error', error);
      NotificationManager.error(error.message, 'Error');
      return -1;
    }
  };
};

export const getDashboardBalance = () => {
  return async (dispatch) => {
    try {
      const { data } = await _getBalance();
      if (data.error.status == 1) {
        // NotificationManager.error(data.error.message, 'Error');
        return -1;
      } else {
        dispatch({ type: GETBALANCE_SUCCESS, payload: data.content });

        // NotificationManager.success(
        //   'Dashboard Information up to date',
        //   'Success'
        // );
        return data.content;
      }
    } catch (error) {
      console.log('error', error);
      NotificationManager.error(error.message, 'Error');
      return -1;
    }
  };
};
